import React from 'react';
import { NO_DATA_FALLBACK } from '../configuration';

const escapeRegExp = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const highlightSearchTerm = (text: string, searchTerm: string): JSX.Element => {
    if (!searchTerm.trim()) {
        return <span>{text}</span>;
    }
    const escaped = escapeRegExp(searchTerm);
    // eslint-disable-next-line security/detect-non-literal-regexp
    const regex = new RegExp(`(${escaped})`, 'gi');
    const parts = text.split(regex);

    return (
        <span>
            {parts?.map((part, index) =>
                part.toLowerCase() === searchTerm.toLowerCase() ? (
                    <span key={index} className='lxs-create-order__highlight-search-term'>
                        {part}
                    </span>
                ) : (
                    part
                )
            )}
        </span>
    );
};

export const displayTableCellValue = (value?: string, globalFilter?: string) => {
    return highlightSearchTerm(value?.trim() ? value : NO_DATA_FALLBACK, globalFilter ?? '');
};
